import { useQuery } from "@tanstack/react-query";
import { apiCall } from "../lib/api";

export type FormRecord = {
  invoiceId: string;
  customerId?: string;
  customerName?: string;
  timestamp?: string;
  dropOffForm?: string;
  dropOffFormType?: string;
  mailbackLabel?: string;
  mailbackLabelType?: string;
  mailInLabel?: string;
  mailInLabelType?: string;
  mailbackR2Key?: string;
  mailInR2Key?: string;
  [k: string]: unknown;
};

export function useForms(
  params: { search: string; startDate: string; endDate: string; showAll: boolean },
  enabled: boolean,
) {
  return useQuery({
    queryKey: ["forms", params.search, params.startDate, params.endDate, params.showAll],
    queryFn: () => {
      let url = "forms?";
      if (params.search) url += `search=${encodeURIComponent(params.search)}&`;
      if (params.startDate) url += `startDate=${params.startDate}&`;
      if (params.endDate) url += `endDate=${params.endDate}&`;
      if (params.showAll) url += "showAll=true&";
      return apiCall<{ records: FormRecord[] }>(url);
    },
    enabled,
  });
}
